import React, { Component } from 'react';

import './navigation.css';

import { Nav } from 'react-bootstrap';

import { connect } from "react-redux";
import { withRouter } from "react-router";
import Modal from "react-bootstrap/Modal";
import AddNewReportForm from "./../Forms/AddNewReportForm/addNewReportForm.jsx";
import AddNewUser from './../Forms/AddNewUser/addNewUser.jsx';
import AddNewClient from './../addClient/addClient.jsx';


class Navigation extends Component {
    constructor() {
        super();
        this.state = {
            Menu1: 'Home',
            Menu2: 'Add Report', 
            show:false,
            isUserCreate:false,
            showNewUser:false,
            showGetLink:false,
            showClient:false,
        };
    }

    onClick = () => {
        this.props.history.push({
            pathname:"/"
        })
    };

    onCreateNew = () => {
        this.setState({show:true});   
    };
    
    handleClose =  () => {
        this.setState({show:false});
    }

    componentDidMount(){
        if(localStorage.getItem("userType") === "superAdmin"){
            this.setState({isUserCreate:true});
        }
    }
    onUserCreate = () => {
        this.setState({showNewUser:true});
    }

    onGetLink = () => {
        this.props.history.push({
            pathname:"/getusers"
        });
    }
    handleCreateUser = () => {
        this.setState({showNewUser:false});
    }

    handleReportClose = () => {
        this.setState({show:false});
        window.location.reload(true);
    }

    onClientCreate = () => {
        this.setState({showClient:true});
    }
    onCloseClient = () => {
        this.setState({showClient:false});
        this.props.history.push({
            pathname:"/"
        })
    }

    onDeleteClient = () => {
        this.props.history.push({
            pathname:"/deleteclient"
        })
    };

    onCostFormula = () => {
        this.props.history.push({
            pathname:"/costformula"
        });
    }
    

    
    render() {
        return (
            <div className="">
                <nav className="nav nav-underline" style={{background: '#f0f0f0'}}>
                    <Nav.Link style={{borderRight: '1px solid #cfcfcf'}} onClick={this.onClick}>{this.state.Menu1}</Nav.Link>
                    <Nav.Link style={{borderRight: '1px solid #cfcfcf'}} onClick={this.onCreateNew}>{this.state.Menu2}</Nav.Link>
                    { this.state.isUserCreate && <Nav.Link style={{borderRight: '1px solid #cfcfcf'}} onClick={this.onUserCreate}>Create new user</Nav.Link> }
                    { this.state.isUserCreate && <Nav.Link style={{borderRight: '1px solid #cfcfcf'}} onClick={this.onGetLink}>Delete user</Nav.Link> }
                    { this.state.isUserCreate && <Nav.Link style={{borderRight: '1px solid #cfcfcf'}} onClick={this.onClientCreate}>Create Client</Nav.Link>}
                    { this.state.isUserCreate && <Nav.Link style={{borderRight: '1px solid #cfcfcf'}} onClick={this.onDeleteClient}>Delete Client</Nav.Link>}
                    {/* { this.state.isUserCreate && <Nav.Link style={{borderRight: '1px solid #cfcfcf'}} onClick={this.onCostFormula}>Cost Formula</Nav.Link>} */}
                </nav>
                <Modal size="lg" show={this.state.show} onHide={this.handleClose} className="modal-size">
                    <Modal.Header closeButton>
                        <div className="row col-md-12">
                            <Modal.Title className="col-md-6 heading-details">Add new report</Modal.Title>
                        </div>   
                    </Modal.Header>
                    <Modal.Body className="modal-body" style={{"overflowY":"auto"}}>
                        <div>
                            <AddNewReportForm handleClose={this.handleClose} onSave={this.handleReportClose}/>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal show={this.state.showNewUser} onHide={this.handleCreateUser} className="modal-size">
                    <Modal.Header closeButton>
                        <div className="row col-md-12">
                            <Modal.Title className="col-md-6 heading-details">Add new user</Modal.Title>
                        </div>   
                    </Modal.Header>
                    <Modal.Body className="modal-body" style={{"overflowY":'auto'}}>
                        <div>
                            <AddNewUser onSave={this.handleCreateUser} />
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal show={this.state.showClient} onHide={this.onCloseClient} className="modal-size">
                    <Modal.Header closeButton>
                        <div className="row col-md-12">
                            <Modal.Title className="col-md-6 heading-details"> Add new client</Modal.Title>
                        </div> 
                    </Modal.Header>
                    <Modal.Body className="modal-body" style={{"overflowY":'auto'}}>
                        <div>
                            <AddNewClient onSave={this.onCloseClient} />
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    auth:state.auth
});

export default withRouter(connect(mapStateToProps)(Navigation))


// WEBPACK FOOTER //
// ./src/components/Navigation/navigation.jsx